import * as api from './service-now.api';
import * as mutations from './service-now.mutations';

export * from './service-now.api';
export * from './service-now.mutations';

export default { ...api, ...mutations };
